import { Card } from "antd";

function Documention() {
  return <Card>TechnicalData</Card>;
}

export default Documention;
